module.exports = __webpack_public_path__ + "static/startupJobs-ccf997c383e62cf69f889b57e022d4dc.png";